const A4_RATIO = 210 / 297;
const MIN_WIDTH = 500;
const MAX_VIEWPORT_SHARE = 0.9;

// What the document drawers' chrome takes at this app's styles (measured):
// Element's drawer header with the app's 20px margin under it, the
// `.drawer-footer` with its buttons and border, and the preview's padding
// (2rem top and bottom, 20px each side). Only for the estimate below; the
// exact figure is measured off the rendered drawer a tick later.
const HEADER_HEIGHT = 65;
const FOOTER_HEIGHT = 69;
const PREVIEW_PADDING_Y = 64;
const PREVIEW_PADDING_X = 40;

const clampWidth = (width) => Math.min(Math.max(width, MIN_WIDTH), Math.floor(window.innerWidth * MAX_VIEWPORT_SHARE));

// The width before the drawer has any DOM to measure: set it when the drawer
// starts to open, so it slides in at (almost) its final width instead of
// opening wide and snapping back once measured.
export const a4DrawerSizeEstimate = () => {
    const pageHeight = window.innerHeight - HEADER_HEIGHT - FOOTER_HEIGHT - PREVIEW_PADDING_Y;

    return `${clampWidth(Math.round(pageHeight * A4_RATIO + PREVIEW_PADDING_X))}px`;
};

// The width, in px, that lets a whole DIN A4 page stand in a document drawer:
// the height the preview has between the drawer's header and footer, times
// the page ratio, plus the preview's own side padding. Measured off the rendered
// drawer, so a taller footer or another header simply yields another width.
// Clamped to what a page needs to stay readable and to what the viewport has.
//
//   fitDrawer() {                                  // bound to the drawer's @open
//       this.drawerSize = a4DrawerSizeEstimate()
//       this.$nextTick(() => { this.drawerSize = a4DrawerSize(this.$el) || this.drawerSize })
//   }
//
// and again on window resize.
export const a4DrawerSize = (wrapper) => {
    const drawer = wrapper && wrapper.querySelector ? wrapper.querySelector('.el-drawer') : null;
    if (!drawer) return null;

    const preview = drawer.querySelector('.preview');
    if (!preview) return null;

    // The preview's height does not depend on the drawer's width (it fills
    // what header and footer leave), so it is the page's height plus padding.
    const previewStyles = window.getComputedStyle(preview);
    const paddingY = parseFloat(previewStyles.paddingTop) + parseFloat(previewStyles.paddingBottom);
    const paddingX = parseFloat(previewStyles.paddingLeft) + parseFloat(previewStyles.paddingRight);
    const pageHeight = preview.clientHeight - paddingY;

    return `${clampWidth(Math.round(pageHeight * A4_RATIO + paddingX))}px`;
};
